import './JiraCredentialsEditButton.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { EditOutlined } from '@ant-design/icons';
import { JiraCredentialsUpdate } from './JiraCredentialsUpdate';
import React from 'react';
import { useBoolean } from '@hooks';

import { Button, FormInstance, Popover } from 'antd';

export interface JiraCredentialsEditButtonProps {
	form: FormInstance<unknown>;
}

export const JiraCredentialsEditButton: React.FC<JiraCredentialsEditButtonProps> = ({ form }) => {
	const [ editing, handleSetEditing ] = useBoolean(false);

	return (
		<Popover
			classNames={ { root: 'jira-credentials-edit' } }
			content={
				<JiraCredentialsUpdate
					form={ form }
					onClose={ handleSetEditing.off } />
			}
			onOpenChange={ handleSetEditing.toggle }
			open={ editing }
			placement='bottomLeft'
			trigger='click'>
			<Button
				icon={ <EditOutlined /> }
				type='link'>{ COPY_SPECIFIC.EDIT_SETTINGS }
			</Button>
		</Popover>
	);
};
